export const getPostbackMessage = message => {
  return {
    text: message.postback.title,
    type: 'text',
    isFromBot: message.isFromBot,
  }
}
